<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card">
					<div class="card-header bg-info text-white text-left">
						Gestión de libretas
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body pt-0 pb-0">
						<div class="row p-0">
							<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 p-0 text-left" style="border-right:1px solid #e0e0e0;">
								<div class="table-responsive">
									<table class="table table-condensed table-striped m-0">
										<thead class="bg-dark text-white">
											<tr>
												<th>Selecciona libreta</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="libreta in listadoLibretas" :key="libreta.ID_libreta" :class="(ID_libreta === libreta.ID_libreta) ? 'activa fila' : 'fila'" @click="setLibreta(libreta.ID_libreta)">
												<td>
													<span class="fa fa-address-book mr-2"></span>
													{{libreta.nombre}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 bg-light p-3 text-left" v-if="libreta">
								<h4><b>Información básica</b></h4>
								<div class="form-group">
									<label for="">Nombre</label>
									<input type="text" class="form-control" v-model="libreta.nombre">
								</div>
								<hr>
								<div class="form-group">
									<label for="">Descripción</label>
									<textarea class="form-control" rows="4" v-model="libreta.descripcion"></textarea>
								</div>
								<hr>
								<h4><b>Permisos</b></h4>
								<table class="table table-condensed bg-white table-striped" style="border: 1px solid #e0e0e0;">
									<thead>
										<tr>
											<th colspan="2">
												<div style="position:relative;">
													<input-query class="form-control" input-class="form-control" :realtime="true" url="libreta-direcciones/php/buscaUsuariosGrupos.php" @selected="nuevoPermiso($event)" placeholder="Busca un usuario o un grupo"></input-query>
												</div>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="permiso in listadoPermisos" :key="permiso.tipo+'_'+permiso.ID">
											<td>
												<span class="fa fa-w mr-2" :class="(permiso.tipo === 'grupo') ? 'fa-users' : 'fa-user'"></span>
												{{permiso.nombre}}
											</td>
											<td class="text-right">
												<div class="btn-group">
													<button class="btn btn-sm" :class="(permiso.escritura) ? 'btn-primary' : 'btn-default'" @click="toggleEscritura(permiso.tipo, permiso.ID)">
														<span class="fa fa-edit"></span>
													</button>
													<button class="btn btn-sm btn-danger" @click="quitaPermiso(permiso.tipo, permiso.ID)">
														<span class="fa fa-trash"></span>
													</button>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
								<hr>
								<div class="row">
									<div class="col">
										<button class="btn btn-block btn-primary" @click="guardar()">
											<span class="fa fa-save mr-2"></span>
											Guardar
										</button>
									</div>
									<div class="col">
										<button class="btn btn-block btn-danger" @click="eliminar()">
											<span class="fa fa-trash mr-2"></span>
											Eliminar
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-danger btn-sm" @click="nueva()">
							<span class="fa fa-plus mr-2"></span>
							Nueva libreta
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import API from '../service'
export default {
	data () {
		return {
			listadoLibretas: [],
			ID_libreta: null,
			libreta: null
		}
	},
	created () {
		this.getLibretas()
	},
	computed: {
		listadoPermisos () {
			const arr = []

			if (this.libreta !== null) {
				// Primero los grupos
				for (let i = 0; i < this.libreta.grupos.length; i++) {
					arr.push({
						tipo: 'grupo',
						ID: this.libreta.grupos[i].ID_rel,
						nombre: (this.libreta.grupos[i].ID_grupo !== null) ? this.libreta.grupos[i].info.nombre : 'Grupo desconocido',
						escritura: this.libreta.grupos[i].escritura
					})
				}

				for (let i = 0; i < this.libreta.usuarios.length; i++) {
					arr.push({
						tipo: 'usuario',
						ID: this.libreta.usuarios[i].ID_rel,
						nombre: this.libreta.usuarios[i].info.nombre + ' ' + this.libreta.usuarios[i].info.apellidos,
						escritura: this.libreta.usuarios[i].escritura
					})
				}
			}

			return arr
		}
	},
	methods: {
		getLibretas () {
			API.getLibretas(true)
				.then(res => {
					this.listadoLibretas = res.data.libretas
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nueva () {
			this.libreta = {
				ID_libreta: null,
				nombre: '',
				descripcion: '',
				usuarios: [],
				grupos: []
			}

			this.ID_libreta = null
		},
		setLibreta (idLibreta) {
			API.getLibreta(idLibreta)
				.then(res => {
					this.libreta = res.data.libreta
					this.ID_libreta = idLibreta
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nuevoPermiso (ev) {
			if (ev.datos.tipo === 'grupo') {
				// es un grupo
				for (let i = 0; i < this.libreta.grupos.length; i++) {
					if (this.libreta.grupos[i].ID_grupo === ev.datos.ID_grupo) {
						return
					}
				}

				this.libreta.grupos.push({
					ID_libreta: this.libreta.ID_libreta,
					ID_rel: null,
					ID_grupo: ev.datos.ID_grupo,
					escritura: false,
					info: {
						nombre: ev.datos.nombre
					}
				})
			} else {
				// es un usuario
				for (let i = 0; i < this.libreta.usuarios.length; i++) {
					if (this.libreta.usuarios[i].ID === ev.datos.ID) {
						return
					}
				}

				this.libreta.usuarios.push({
					ID_libreta: this.libreta.ID_libreta,
					ID_rel: null,
					ID_usuario: ev.datos.ID,
					escritura: false,
					info: {
						ID: ev.datos.ID,
						nombre: ev.datos.nombre
					}
				})
			}
		},
		toggleEscritura (tipo, ID) {
			if (tipo === 'grupo') {
				for (let i = 0; i < this.libreta.grupos.length; i++) {
					if (this.libreta.grupos[i].ID_rel === ID) {
						this.libreta.grupos[i].escritura = (this.libreta.grupos[i].escritura !== true && this.libreta.grupos[i].escritura !== 1)
						return
					}
				}
			} else {
				for (let i = 0; i < this.libreta.usuarios.length; i++) {
					if (this.libreta.usuarios[i].ID_rel === ID) {
						this.libreta.usuarios[i].escritura = (this.libreta.usuarios[i].escritura === false)
						return
					}
				}
			}
		},
		quitaPermiso (tipo, ID) {
			if (tipo === 'grupo') {
				for (let i = 0; i < this.libreta.grupos.length; i++) {
					if (this.libreta.grupos[i].ID_rel === ID) {
						this.libreta.grupos.splice(i, 1)
						return
					}
				}
			} else {
				for (let i = 0; i < this.libreta.usuarios.length; i++) {
					if (this.libreta.usuarios[i].ID_rel === ID) {
						this.libreta.usuarios.splice(i, 1)
						return
					}
				}
			}
		},
		guardar () {
			if (this.libreta.nombre === '') {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir el nombre de la libreta'
				})
				return
			}

			API.setLibreta(this.libreta)
				.then(res => {
					let encontrado = false
					for (let i = 0; i < this.listadoLibretas.length; i++) {
						if (this.listadoLibretas[i].ID_libreta === res.data.libreta.ID_libreta) {
							this.listadoLibretas[i] = res.data.libreta
							encontrado = true
						}
					}

					if (!encontrado) {
						this.listadoLibretas.push(res.data.libreta)
					}

					this.getLibretas()
					this.$store.commit('alertas/alert', {
						titulo: 'Guardada',
						mensaje: 'Se han guardado los cambios'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar libreta',
				mensaje: `¿Quieres eliminar esta libreta?
				Todos los contactos que no estén asignados a otras libretas quedarán huérfanos`,
				callback: (acepta) => {
					if (acepta) {
						API.eliminarLibreta(this.libreta.ID_libreta)
							.then(res => {
								this.getLibretas()
								this.libreta = null
								this.ID_libreta = null
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
	tr.fila {
		cursor: pointer;
	}
	tr.activa {
		background-color: darkred !important;
		color: white;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/libreta-direcciones/vue/libretas/gestion-libretas.vue